<div #content class="h-100">
  <div class="card h-100 mb-3">
    <!-- Card Header -->
    <div class="card-header bg-white pdf-exclude">
      <div class="row">
        <div class="col-12">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <h6 class="m-0 me-2">{{ "REPORTS.view.title" | translate }}</h6>
              <div class="d-flex align-items-center">
                <button
                  mat-icon-button
                  class="pdf-icon icon-clean"
                  style="height: auto !important"
                  color="primary"
                  (click)="exportPDFData()"
                  [matTooltip]="
                    'REPORTS.view.filter.buttons.report-download' | translate
                  "
                  matTooltipPosition="above"
                  aria-label="Download PDF Report"
                >
                  <mat-icon class="icon-compact ms-2">picture_as_pdf</mat-icon>
                </button>
              </div>
            </div>

            <button
              mat-stroked-button
              class="d-flex align-items-center justify-content-between"
              color="primary"
              (click)="toggleSearchInputs()"
              [matTooltip]="'REPORTS.view.filter.tooltip' | translate"
              matTooltipPosition="above"
              aria-label="Toggle filters"
            >
              <mat-icon>tune</mat-icon>
              <span>{{ "REPORTS.view.filter.title" | translate }}</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Filter Panel -->
      <div *ngIf="showSearchInputs">
        <div class="row align-items-center compact-inputs dropdown-pd-none">
          <!-- Field Dropdown -->
          <div class="col-xl-6 col-md-4 col-sm-6 col-12 mb-2">
            <div class="d-flex justify-content-start align-items-center">
              <div class="ms-1 flex-grow-1">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{
                    "REPORTS.view.filter.field.placeholder" | translate
                  }}</mat-label>
                  <mat-select
                    #fieldSelect
                    (selectionChange)="selectSearch($event.value, 'field')"
                  >
                    <mat-select-trigger>
                      {{ searchView["field"] }}
                    </mat-select-trigger>
                    <mat-option value="undefined" disabled>
                      {{ "REPORTS.view.filter.field.placeholder" | translate }}
                    </mat-option>
                    <mat-option *ngFor="let e of filterAttributes" [value]="e">
                      <div class="d-flex align-items-center">
                        <span
                          class="badge me-2 fw-light"
                          [ngClass]="getButtonClass(e['type'])"
                        >
                          {{ getButtonLabels(e["type"]) }}
                        </span>
                        <span class="text-truncate" [title]="e['label']">
                          {{ e["label"] }}
                        </span>
                      </div>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <button
                mat-icon-button
                [matTooltip]="'REPORTS.view.filter.infoTooltip' | translate"
                matTooltipPosition="above"
                class="icon-center icon-clean"
                aria-label="Field information"
              >
                <mat-icon class="text-secondary icon-compact">info</mat-icon>
              </button>
            </div>
          </div>

          <!-- Condition Select -->
          <div class="col-xl-6 col-md-4 col-sm-6 col-12 mb-2">
            <div class="d-flex justify-content-start align-items-center">
              <div class="ms-1 flex-grow-1">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{
                    "REPORTS.view.filter.condition.placeholder" | translate
                  }}</mat-label>
                  <mat-select
                    [(ngModel)]="searchData['condition']"
                    id="condition"
                    name="condition"
                  >
                    <mat-option value="undefined" disabled>
                      {{
                        "REPORTS.view.filter.condition.placeholder" | translate
                      }}
                    </mat-option>
                    <mat-option
                      *ngFor="let e of operators"
                      [value]="e['value']"
                    >
                      {{ e["label"] }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <button
                mat-icon-button
                [matTooltip]="'REPORTS.view.filter.infoTooltip' | translate"
                matTooltipPosition="above"
                class="icon-center icon-clean"
                aria-label="Condition information"
              >
                <mat-icon class="text-secondary icon-compact">info</mat-icon>
              </button>
            </div>
          </div>

          <!-- Value Input -->
          <div class="col-xl-6 col-md-4 col-sm-6 col-12 mb-2">
            <div class="d-flex justify-content-start align-items-center px-1">
              <div class="compact-inputs dropdown-pd-none flex-grow-1">
                <!-- Text input -->
                <mat-form-field
                  appearance="outline"
                  class="w-100"
                  *ngIf="
                    selectedSearchAtt != 'number' &&
                    selectedSearchAtt != 'expression' &&
                    selectedSearchAtt != 'long' &&
                    selectedSearchAtt != 'date'
                  "
                >
                  <mat-label>{{
                    "REPORTS.view.filter.value.textPlaceholder" | translate
                  }}</mat-label>
                  <input
                    matInput
                    [(ngModel)]="searchData['value']"
                    name="value"
                    id="value"
                    type="text"
                  />
                </mat-form-field>

                <!-- Number input -->
                <mat-form-field
                  appearance="outline"
                  class="w-100"
                  *ngIf="
                    selectedSearchAtt === 'number' ||
                    selectedSearchAtt === 'expression' ||
                    selectedSearchAtt === 'long'
                  "
                >
                  <mat-label>{{
                    "REPORTS.view.filter.value.numberPlaceholder" | translate
                  }}</mat-label>
                  <input
                    matInput
                    [(ngModel)]="searchData['value']"
                    name="value"
                    id="value"
                    type="number"
                  />
                </mat-form-field>

                <!-- Date input — exactly as admin component -->
                <mat-form-field
                  appearance="outline"
                  class="w-100"
                  *ngIf="selectedSearchAtt === 'date'"
                >
                  <mat-label>{{
                    "REPORTS.view.filter.value.datePlaceholder" | translate
                  }}</mat-label>
                  <input
                    matInput
                    type="date"
                    #dateInput
                    [(ngModel)]="searchData['value']"
                    name="value"
                    id="value"
                    [placeholder]="
                      'REPORTS.view.filter.value.datePlaceholder' | translate
                    "
                  />
                  <button
                    mat-icon-button
                    matSuffix
                    type="button"
                    class="icon-pd-none"
                    (click)="dateInput.showPicker()"
                    aria-label="Open date picker"
                  >
                    <mat-icon class="icon-compact text-secondary"
                      >calendar_today</mat-icon
                    >
                  </button>
                </mat-form-field>
              </div>
              <button
                mat-icon-button
                [matTooltip]="'REPORTS.view.filter.infoTooltip' | translate"
                matTooltipPosition="above"
                class="icon-center icon-clean"
                aria-label="Value information"
                *ngIf="selectedSearchAtt"
              >
                <mat-icon class="text-secondary icon-compact">info</mat-icon>
              </button>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="col-auto pe-1 mb-2">
            <button
              mat-stroked-button
              color="primary"
              [disabled]="
                !searchData['value'] &&
                !searchData['condition'] &&
                !searchData['field']
              "
              (click)="addSearchData(); fieldSelect.writeValue(null)"
              class="d-flex align-items-center"
            >
              <mat-icon class="me-1">add</mat-icon>
              {{ "REPORTS.view.filter.buttons.add" | translate }}
            </button>
          </div>

          <div class="col-auto pe-1 mb-2 pdf-exclude">
            <button
              mat-stroked-button
              color="primary"
              (click)="searchAndDrawnew(true)"
              class="d-flex align-items-center"
            >
              <mat-icon class="me-1">search</mat-icon>
              {{ "REPORTS.view.filter.buttons.search" | translate }}
            </button>
          </div>

          <div class="col-auto pe-1 mb-2 pdf-exclude">
            <button
              mat-stroked-button
              color="primary"
              (click)="resetSearchCriteria(); fieldSelect.writeValue(null)"
              class="d-flex align-items-center"
            >
              <i class="fa fa-eraser"></i>
              <span class="ms-2">{{
                "REPORTS.view.filter.buttons.clear" | translate
              }}</span>
            </button>
          </div>
        </div>

        <!-- Active Filter Chips -->
        <div class="row mt-1">
          <div class="col-12 mb-2">
            <div class="d-flex flex-wrap gap-2 px-1">
              <mat-chip
                *ngFor="let e of searchList; let i = index"
                class="filter-chip"
              >
                {{ e.label }} {{ e.condition }} {{ e.value }}
                <button
                  matChipRemove
                  aria-label="Remove filter"
                  (click)="removeSearchData(i)"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-chip>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Card Body -->
    <div class="col-12">
      <div class="card-body">
        <h6>{{ reportTitle }}</h6>
        <div class="mt-3">
          <div class="table-responsive">
            <p *ngIf="form['error'] == false && form['message']">
              <app-ncs-alert
                [message]="form['message']"
                type="success"
                showAlert="true"
              />
            </p>
            <p *ngIf="form['error'] == true && form['message']">
              <app-ncs-alert
                [message]="form['message']"
                type="danger"
                showAlert="true"
              />
            </p>
            <div *ngIf="loading">
              {{ "REPORTS.view.table.loading" | translate }}
            </div>
            <div *ngIf="!loading">
              <!-- <div [innerHTML]="pivottable"></div>
              <img [src]="pivotUrl" width="100%" /> -->
              <!-- � Table -->
              <div *ngIf="pivottable" [innerHTML]="pivottable" class="table-responsive sticky-bordered-table">
              </div>
              <!-- � Plotly Chart -->
              <iframe *ngIf="chartUrl" [src]="chartUrl" width="100%" height="600px" style="border: none;">
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>